import { fetchUserData } from "./authService";
import { getAccessToken } from "context/OAuth/authService";

const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

const getUserData = async () => {
  const token = getAccessToken();

  if (!token) {
    console.error("No access token found");
    return null;
  }
  console.log("token : ", token);

  try {

    const wpformsData = sessionStorage.getItem('wpforms');
    let wpformsParams = null;


      if (wpformsData) {
      try {
        const parsedWpforms = JSON.parse(wpformsData);
        // Extract individual fields
        wpformsParams = {
          country: parsedWpforms.country,
          gender: parsedWpforms.gender,
          language: parsedWpforms.language,
          profile_picture: parsedWpforms.profile_picture
        };
        console.log('wpforms params to be sent:', wpformsParams);
      } catch (error) {
        console.error('Error parsing wpforms data:', error);
      }
    }

    const response = await fetchUserData(wpformsParams);

    const userData = response?.data;

     // If response is successful, remove wpforms from session storage
    if (response?.status === true || response?.success === true || response?.data) {
      if (wpformsData) {
        sessionStorage.removeItem('wpforms');
        console.log('wpforms data removed from session storage after successful API call');
      }
    }
    
    return userData;
  } catch (error) {
    console.log("Error fetching user data:", error);
    return null;
  }
};

export default getUserData;
